import { RequestError } from '@fora-monorepo/employer-my-pages-common/types';

type ApiErrorType = { response: { data: { message: string }; status: number } };

const isErrorType = (obj: unknown): obj is ApiErrorType => {
  return (
    (obj as ApiErrorType)?.response !== undefined &&
    (obj as ApiErrorType)?.response.status !== undefined &&
    (obj as ApiErrorType)?.response.data !== undefined &&
    typeof (obj as ApiErrorType).response.data.message === 'string'
  );
};

export const createThunkError = (subject: string, error?: unknown): RequestError => {
  return {
    message: `${subject}: ${isErrorType(error) ? error.response.data.message : ''}`,
    code: isErrorType(error) ? error.response.status : 500,
  };
};
